import { useOffline } from '../contexts/OfflineContext';

export default function OfflineIndicator() {
  const { isOnline, syncStatus, pendingChanges } = useOffline();

  if (isOnline && pendingChanges === 0) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '1rem',
        left: '50%',
        transform: 'translateX(-50%)',
        backgroundColor: isOnline ? 'var(--warning)' : 'var(--danger)',
        color: 'white',
        padding: '0.4rem 0.9rem',
        borderRadius: '1.5rem',
        boxShadow: 'var(--shadow-lg)',
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        zIndex: 1000,
        fontSize: '0.75rem',
        fontWeight: '500',
        animation: 'slideUp 0.3s ease',
      }}
    >
      {!isOnline && (
        <>
          <span style={{ fontSize: '0.9rem' }}>📴</span>
          <span>Offline</span>
        </>
      )}
      {isOnline && pendingChanges > 0 && (
        <>
          {syncStatus === 'syncing' && (
            <>
              <div
                style={{
                  width: '12px',
                  height: '12px',
                  border: '2px solid rgba(255, 255, 255, 0.3)',
                  borderTopColor: 'white',
                  borderRadius: '50%',
                  animation: 'spin 0.8s linear infinite',
                }}
              />
              <span>Sync {pendingChanges}...</span>
            </>
          )}
          {syncStatus === 'error' && (
            <>
              <span style={{ fontSize: '0.9rem' }}>⚠️</span>
              <span>Sync-Fehler</span>
            </>
          )}
          {syncStatus === 'idle' && (
            <>
              <span style={{ fontSize: '0.9rem' }}>⏳</span>
              <span>{pendingChanges} ausstehend</span>
            </>
          )}
        </>
      )}
    </div>
  );
}
